import React, { useState } from 'react';

import { Alert } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { datePickerBeforeOnChange } from '@libs/NwMoment';

import { forceReloadPayment, forceReloadPayments, useUpdatePaymentNumber } from '@hooks/API/UsePayments';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWInput, NWDatePicker } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const Wrapper = styled.div`
    input.read-only {
        background-color: ${(props) => props.theme.LayoutBodyBackground} !important;
    }
    .error-message-container {
        margin-top: 2rem;
    }
`;

const EditPaymentNumberDrawer = ({ onClose, paymentID, paymentContactID, number, date }) => {
    const [touchForm, setTouchForm] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const { mutateAsync: onUpdatePaymentNumber } = useUpdatePaymentNumber();

    const initialValues = {
        Number: number,
        Date: date,
    };

    const savePaymentNumberAndDate = async (values, setSubmitting) => {
        setSubmitting(true);
        try {
            await onUpdatePaymentNumber({
                data: {
                    PaymentID: paymentID,
                    Number: values.Number,
                    Date: values.Date,
                },
            });
            forceReloadPayment(values.ID);
            forceReloadPayments(paymentContactID);
            onClose();
        } catch (e) {
            setErrorMessage(e.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Payment Number and Date">
            <Wrapper>
                <Formik
                    initialValues={initialValues}
                    onSubmit={(values, { setSubmitting }) => {
                        savePaymentNumberAndDate(values, setSubmitting);
                    }}
                    validationSchema={Yup.object().shape({
                        Number: Yup.string().required('A number/string is required'),
                        Date: Yup.string().required('A date is required'),
                    })}
                >
                    {({ isSubmitting, values, setFieldValue, handleSubmit }) => (
                        <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                            <Field
                                component={NWDatePicker}
                                label="Invoice Date"
                                name="Date"
                                format="MMM DD, YYYY"
                                getCalendarContainer={(triggerNode) => triggerNode.parentNode}
                                style={{ width: '100%' }}
                                value={values.Date ? getMoment(values.Date) : null}
                                manipulateValue={datePickerBeforeOnChange}
                            />
                            <Field
                                component={NWInput}
                                label="Payment Number/Code"
                                name="Number"
                                maxLength={50}
                                type="text"
                                value={values.Number}
                            />
                            <NwFormButtonsBar
                                marginTop="4rem"
                                left={
                                    <NwCancelButton
                                        disabled={isSubmitting}
                                        onClick={() => {
                                            setTouchForm(false);
                                            onClose();
                                        }}
                                    />
                                }
                                right={
                                    <NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />
                                }
                            />
                            <div className="error-message-container">
                                {errorMessage && <Alert message={errorMessage} type="error" showIcon />}
                            </div>
                        </NwForm>
                    )}
                </Formik>
            </Wrapper>
        </NwDrawer>
    );
};

export default EditPaymentNumberDrawer;
